/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class CreepyCarnivalTwoSoundConfig implements ISoundConfig {

    public static instance:CreepyCarnivalTwoSoundConfig = new CreepyCarnivalTwoSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string[] = ["ambloop1", "ambloop2", "ambloop1", "ambloop1", "ambloop2"];
    BONUS_GAME_AMBIANCE: string = "bonusloop";

    //Reel Anticipation Sounds
    ANTICIPATION: string = "anticipation";
    ANTICIPATION_STOP: string = "anticipation-stop";

    //Win Sounds
    BIGWIN: string = "bigwin";
    BIGWIN_ENDS: string = "bigwinEnds";
    NORMAL_WIN: string = "countup3";

    //Wild Attention
    WILD_ATTENTION: string = "wild-attention";
    WILD_ATTENTION_2: string = "wild-attention2";
    WILD_ATTENTION_3: string = "wild-attention3";
    WILD_ATTENTION_4: string = "wild-attention4";

    //Scatter Attention
    SCATTER_ATTENTION: string = "scatter-attention";
    SCATTER_ATTENTION_WIN: string = "scatter-attention-win";

    //Multipliers
    X5_MULTIPLIER: string = "flickering";
    X5_SMOKE: string = "x5explosion";
    X2_MULTIPLIER_SOUND: string = "multiplierx2";
    X3_MULTIPLIER_SOUND: string = "multiplierx3";

    //Lights On Sound
    LIGHTS_ON: string = "light_on";

    //Free Spin Sounds
    FS_INTRO: string = "freespin-enter2";
    FS_OUTRO: string = "freespin-exit2";
    FS_ADD_SPINS: string = "glasstap";
    EXTRA_SPIN: string = "extra-spins";
    FREESPIN_WIN: string = "freespin-win";

    //Reel Related
    REEL_STOP: string = "reel-stop";
    REEL_SPIN: string = "spin";

    //Star Spin
    SS_COUNT_UP: string = "starspin-meter";
    SS_SCREEN: string = "starspin-enter2";
    SS_EXIT: string = "starspin-exit";
    SS_WIN: string = "starspin-win";
    SS_METER_FULL: string = "starspin-fullmeter";

    //Win Related
    SOUND_STAR_ANIMATION: string = "star-animation";
    FS_WIN_1: string = "win";
    FS_WIN_2: string = "winx2";
    FS_WIN_3: string = "winx3";

    //betline
    BET_LINE_SOUND: string = "betline";

    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelsSpinning";
    REELS_SPINNING_START_ON_SPIN_START:string = "spin";
    REELS_DEFAULT_BOUNCE:string[] = ["reel-stop"];
    // REELS_DEFAULT_STOP?:string[];

    constructor() {
        if(CreepyCarnivalTwoSoundConfig.instance) {
            throw new Error("CreepyCarnivalTwoSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    //Win amount
    getWinAmountSoundName(multiplier: number): string {
        return "win-amount-x" + multiplier;
    }
}